<template>
  <div>
    <h1 class="flex mb-8 font-bold text-3xl group">
      <inertia-link class="flex text-indigo-400 group-hover:text-indigo-600" :href="route('organizations')">
        <icon name="office" class="w-6 h-9 mr-3 fill-indigo-400 group-hover:fill-indigo-600" /> Organizações /
      </inertia-link>
      <span class="ml-1 font-medium">
        Criar
      </span>
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nome" />
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" label="Email" />
          <text-input v-model="form.cpf_cnpj" :error="form.errors.cpf_cnpj" class="pr-6 pb-8 w-full lg:w-1/2" label="CPF/CNPJ" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-1/2" label="Fone" />
          <text-input v-model="form.address" :error="form.errors.address" class="pr-6 pb-8 w-full lg:w-1/2" label="Endereço" />
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label class="form-label">Estado:</label>
            <select id="state" v-model="form.state_id" class="form-select" @change="getCities()">
              <option :value="null" />
              <option v-for="state in states" :key="state.id" :value="state.id">{{ state.name }}</option>
            </select>
          </div>
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label class="form-label">Cidade:</label>
            <select id="city" v-model="form.city_id" class="form-select">
              <option :value="null" />
              <option v-for="city in cities" :key="city.id" :value="city.id">{{ city.name }}</option>
            </select>
          </div>
          <text-input v-model="form.postal_code" :error="form.errors.postal_code" class="pr-6 pb-8 w-full lg:w-1/2" label="CEP" />
          <file-input v-model="form.photo" :error="form.errors.photo" class="pr-6 pb-8 w-full lg:w-1/2" type="file" accept="image/*" label="Imagem" />
          <select-input v-model="form.active" :error="form.errors.active" class="pr-6 pb-8 w-full lg:w-1/2" label="Ativo">
            <option :value="null" />
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Criar Organização</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import axios from 'axios'
import FileInput from '@/Shared/FileInput'

export default {
  metaInfo: { title: 'Create Organization' },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    Icon,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      states: null,
      cities: null,
      form: this.$inertia.form({
        name: null,
        email: null,
        cpf_cnpj: null,
        phone: null,
        address: null,
        state_id: null,
        city_id: null,
        postal_code: null,
        photo: null,
        active: null,
      }),
    }
  },
  mounted() {
    this.getStates()
  },
  methods: {
    store() {
      this.form.post(this.route('organizations.store').url())
    },
    getStates() {
      axios
        .get(this.route('states'))
        .then(response => (this.states = response.data))
    },
    getCities() {
      axios
        .get(this.route('cities'), {
          params: {
            stateId:this.form.state_id,
          },
        })
        .then(response => (this.cities = response.data))
    },
  },
}
</script>
